(function(window, angular) {'use strict';

  var app = angular.module('app');

  /**
   *
   * lead App Controller
   *
   */
  app.controller('leadFormController', ['$scope','leadService','configService', 'origineService', '$window', 'pipeService', '$uibModal',
                                function($scope,  leadService,  configService,   origineService,   $window,   pipeService,   $uibModal) {
    $scope.my_user_id = null;
    $scope.origines2 = [];
    $scope.type_affectation = 'none';
    $scope.pipe_status = [];
    $scope.offset = 0;
    $scope.lead = {
      int_id_usr_affect:null,
      int_id_age_affect:null,
      int_lead_date:new Date(),
      int_lead_importance:'1',
      status_id:'todo',
      int_lead_valid:null,
    }

    /**
     * init controller
     * @return {none}
     */
    $scope.init = function(lead_id) {
      $scope.my_user_id = configService.uid;

      if( lead_id ) {
        $scope.loading = false;

        leadService.get(lead_id).then(function(lead) {
          $scope.lead = $scope.initLead(lead);
          $scope.origineChanged();
          $scope.loading = false;
        });
      }
      else {
        $scope.initLead($scope.initLead);
      }
    }

    $scope.getStatusListIdx = function(status) {
      for( var i=0; i<$scope.status_list.length; i++ ) {
        if( $scope.status_list[i].id == status ) {
          return i;
        }
      }
      return -1;
    }

    $scope.isStatusCompleted = function(status) {
      // are we before the active status ? return true else false
      return $scope.getStatusListIdx(status) < $scope.getStatusListIdx($scope.lead.status_id);
    }

    /**
     * update origines 2 sbox
     * @return {none}
     */
    $scope.origineChanged = function() {
      $scope.origines2 = [];

      $scope.pipe_status = [{
        pss_lib: configService.locale.status.pipe, // i18n label
        pss_id:'pipe',
      }];

      $scope.status_list = [];
      angular.forEach(configService.locale.status, function(label, key) {
        $scope.status_list.push({
          id:key,
          label:label,
        });
      });

      if( !$scope.lead.int_id_ore ) {
        return;
      }

      $scope.loading_origines2 = true;
      $scope.offset = 0;

      origineService.get($scope.lead.int_id_ore).then(function(origine) {
        $scope.origine = origine;
        if( origine.ore_id_pie ) {
          pipeService.get(origine.ore_id_pie).then(function(pipe) {
            if( pipe.status && pipe.status.length ) {
              $scope.pipe_status = pipe.status;

              $scope.status_list.splice(1,1);
              for(var i=0; i<pipe.status.length; i++) {
                var data = pipe.status[i];

                $scope.status_list.splice($scope.status_list.length-1, 0, {
                  id:data.pss_id,
                  label:data.pss_lib,
                });
              }

              var pos = $scope.getStatusListIdx($scope.lead.status_id);
              $scope.offset = pos - pos % 4;
            }
          });
        }

      })

      var params = {
        ore_id_ore: $scope.lead.int_id_ore,
      };

      origineService.search(params).then(function(origines) {
        $scope.origines2 = origines;
        $scope.loading_origines2 = false;
      });
    }

    $scope.typeAffectionChanged = function() {
      $scope.lead.int_id_usr_affect = null;
      $scope.lead.int_id_age_affect = null;
    }

    /**
     * do some specific controller init from this lead object
     * @param  {object} lead get from server
     * @return {object} lead with initialized value
     */
    $scope.initLead = function(lead) {
      $scope.type_affectation = 'none';
      lead.validation = lead.int_lead_valid == null ? 'none' : lead.int_lead_valid;
      lead.int_id_ore = '' + lead.int_id_ore; // convert it to string
      lead.int_id_fam = '' + lead.int_id_fam; // convert it to string

      lead.old_int_id_pss = lead.int_id_pss;
      lead.old_int_lead_status = lead.int_lead_status;

      if( lead.int_id_usr_affect ) {
        $scope.type_affectation = 'user';
      }
      else if( lead.int_id_age_affect ) {
        $scope.type_affectation = 'agence';
      }

      lead.status_id = lead.int_id_pss > 0 ? lead.int_id_pss : lead.int_lead_status;

      return lead;
    }


    /**
     * save lead
     * @param  {form} form
     * @return {none}
     */
    $scope.save = function(form) {
      if( form.$invalid ) {
        form.show_errors = true;
        return;
      }

      form.show_errors = false;
      form.errors = [];

      $scope.loading = true;
      $scope.lead.int_lead_valid = $scope.lead.validation == 'none' ? null : $scope.lead.validation;

      if( parseInt($scope.lead.status_id) == $scope.lead.status_id ) {
        // integer values => id
        $scope.lead.int_id_pss = parseInt($scope.lead.status_id);
        $scope.lead.int_lead_status = 'pipe';
      }
      else {
        $scope.lead.int_lead_status = $scope.lead.status_id;
        $scope.lead.int_id_pss = null;
      }

      var saveLead = function(extra_data) {
        if( extra_data ) {
          $scope.lead.log_data = extra_data;
        }

        leadService.save($scope.lead).then(function(lead) {
          $scope.lead = lead;
          $window.location = '/lead/'+lead.int_id;
        }, function(error) {
          $scope.handleError(error, form);
          $scope.loading = false;

          if( error.status == 500 ) {
            $window.location = '/error/500';
          }
        });
      }

      if( $scope.lead.int_id && !$scope.lead.log_data && ($scope.lead.old_int_lead_status != $scope.lead.int_lead_status || $scope.lead.old_int_id_pss != $scope.lead.int_id_pss) ) {
        // status has changed !
        // ask for a comment
        $scope.openCommentModal(saveLead);
      }
      else {
        saveLead();
      }

    }

    /**
     * comment log
     */
    $scope.openCommentModal = function (callback) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'myModalContent.html',
        controller: 'ModalInstanceCtrl',
        controllerAs: 'this',
        size: 'small',
        resolve: {
        }
      });

      modalInstance.result.then(function (data) {
        console.log(data);
        callback(data);
      });
    };

    $scope.$watch('lead.validation', function(newVal) {
      if( newVal == 0 ) {
        $scope.lead.status_id = 'done';
        $scope.lead.int_lead_won = '0';
      }
    })

    $scope.$watch('lead.int_lead_nom',function(newVal) {
      if (newVal!=undefined && newVal!='') $scope.lead.int_lead_nom = newVal.toUpperCase();
    })
    $scope.$watch('lead.int_lead_prenom',function(newVal) {
      if (newVal!=undefined && newVal!='') $scope.lead.int_lead_prenom = newVal.toUpperCase();
    })
  }]);

  app.controller('ModalInstanceCtrl', ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
    $scope.ok = function () {
      $uibModalInstance.close({
        comment:$scope.comment,
      });
    };
  }]);


})(window, window.angular);
